var React = require('react');

function ArrowDiagonalBlackInvert (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"11.5","stroke":"#000","miterlimit":"10","key":0}),React.createElement("path",{"fill":"none","stroke":"#FFFFFF","miterlimit":"10","d":"M16.6,14.3V7.4H9.7","key":1}),React.createElement("path",{"fill":"none","stroke":"#FFFFFF","miterlimit":"10","d":"M16.6,7.4l-8.9,8.9","key":2})]);
}

ArrowDiagonalBlackInvert.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = ArrowDiagonalBlackInvert;

ArrowDiagonalBlackInvert.default = ArrowDiagonalBlackInvert;
